import * as Sentry from "@sentry/react";

import type { ConnectionFlapEventType } from "~/context/call/connectionHealth/types";

export type ConnectionFlapLogPayload = {
  type: ConnectionFlapEventType;
  socketStatus?: string;
  sipStatus?: string;
  extension?: string | null;
};

export const logConnectionFlap = (payload: ConnectionFlapLogPayload) => {
  console.warn("[ConnectionHealth]", payload);

  Sentry.addBreadcrumb({
    category: "connection_health",
    message: payload.type,
    level: "warning",
    data: payload,
  });
};
